import { Injectable } from "@angular/core";
import { LoadingController } from "@ionic/angular";
@Injectable({
  providedIn: "root",
})
export class IonLoaderService {
  private loading: HTMLIonLoadingElement | null = null;
  private autoDismissTimer: any;

  constructor(public loadingController: LoadingController) {}

  // Simple loader
  async simpleLoader() {
    if (this.loading) {
      await this.dismissLoader(); // dismiss any existing loader
    }
    this.loading = await this.loadingController.create({
      message: "Loading...",
      spinner: "bubbles",
      cssClass: "loaderClass",
    });

    await this.loading.present();

    // Set auto-dismiss after 20 seconds
    this.autoDismissTimer = setTimeout(async () => {
      // console.log('Auto dismissing loader after timeout...');
      await this.dismissLoader();
    }, 20000); // 20000ms = 20 seconds
  }

  async showLoaderWithMessage(message: string) {
    if (this.loading) {
      await this.dismissLoader(); // dismiss any existing loader
    }
    this.loading = await this.loadingController.create({
      message: message,
      spinner: "bubbles",
      cssClass: "loaderClass",
    });

    await this.loading.present();

    // Set auto-dismiss after 20 seconds
    this.autoDismissTimer = setTimeout(async () => {
      // console.log('Auto dismissing loader after timeout...');
      await this.dismissLoader();
    }, 35000); // 20000ms = 20 seconds
  }

  simpleConnector() {
    this.loadingController
      .create({
        message: "Connecting...",
        spinner: "bubbles",
        cssClass: "loaderClass",
      })
      .then((response) => {
        response.present();
      });
  }
  // Dismiss loader
  async dismissLoader() {
    if (this.autoDismissTimer) {
      clearTimeout(this.autoDismissTimer); // Clear the timeout if dismissing manually
      this.autoDismissTimer = null;
    }

    if (this.loading) {
      try {
        await this.loading.dismiss();
        // console.log('Loader dismissed');
      } catch (err) {
        console.log("Dismiss error:", err);
      } finally {
        this.loading = null;
      }
    }
  }
  // Auto hide show loader
  autoLoader() {
    this.loadingController
      .create({
        message: "Loading...",
        spinner: "bubbles",
        duration: 6000,
        cssClass: "loaderClass",
      })
      .then((response) => {
        response.present();
        response.onDidDismiss().then((response) => {
          console.log("Loader dismissed", response);
        });
      });
  }
  // Custom style + hide on tap loader
  customLoader() {
    this.loadingController
      .create({
        message: "Loader with custom style",
        duration: 4000,
        cssClass: "loaderClass",
        backdropDismiss: true,
      })
      .then((res) => {
        res.present();
      });
  }
}
